<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>inventory_2</mat-icon></div>
          <mat-card-title>Comodato</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          labelParametro="Cliente"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Informe os filtros e clique em <strong>Consultar</strong>.
        </div>

        <ng-container *ngIf="consultaRealizada">
          <table mat-table [dataSource]="comodato" class="full-width">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let item">{{ item.id }}</td>
            </ng-container>
            <ng-container matColumnDef="cliente">
              <th mat-header-cell *matHeaderCellDef>Cliente</th>
              <td mat-cell *matCellDef="let item">{{ item.cliente }}</td>
            </ng-container>
            <ng-container matColumnDef="qtd">
              <th mat-header-cell *matHeaderCellDef>Quantidade</th>
              <td mat-cell *matCellDef="let item">{{ item.numeroQuantidade }}</td>
            </ng-container>
            <ng-container matColumnDef="produto">
              <th mat-header-cell *matHeaderCellDef>Produto</th>
              <td mat-cell *matCellDef="let item">{{ item.produto }}</td>
            </ng-container>
            <ng-container matColumnDef="dtEmprestimo">
              <th mat-header-cell *matHeaderCellDef>Data Empréstimo</th>
              <td mat-cell *matCellDef="let item">{{ item.dtEmprestimo | date:'dd/MM/yyyy' }}</td>
            </ng-container>
            <ng-container matColumnDef="dtPrevisaoDevolucao">
              <th mat-header-cell *matHeaderCellDef>Previsão Devolução</th>
              <td mat-cell *matCellDef="let item">{{ item.dtPrevisaoDevolucao | date:'dd/MM/yyyy' }}</td>
            </ng-container>
            <ng-container matColumnDef="dtDevolucao">
              <th mat-header-cell *matHeaderCellDef>Devolução</th>
              <td mat-cell *matCellDef="let item">{{ item.dtDevolucao | date:'dd/MM/yyyy' }}</td>
            </ng-container>
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let item" (click)="$event.stopPropagation()">
                <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(item.id)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" matTooltip="Excluir" (click)="openDialog(item.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
            <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
              (click)="editar(row.id)"></tr>
          </table>

          <mat-paginator [length]="totalElementos" [pageSize]="tamanho"
            [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
          </mat-paginator>
        </ng-container>
      </mat-card>
    </div>
  </div>
</main>
